import { Injectable } from "@angular/core";
import { RateSubscription } from "./model/RateSubscription";

export const CHANNEL_RATE_SUBSCRIPTION: string = "RateSubscriptionChannel";

export interface IRateSubscriptionService {
  hasSubscription(rateSubscription: RateSubscription): Promise<boolean>;

  getActiveSubscriptions(): Promise<Array<RateSubscription>>;

  subscribe(subscription: RateSubscription): Promise<any>;

  unsubscribe(subscription: RateSubscription): Promise<any>;

  unsubscribeWithCheck(rateSubscription: RateSubscription): Promise<any>;
}
